import { queueApi } from "./queue.api";
import { isCompanyParams, isShippingCompanyParams } from "./queue.guards";

export type UseGetQueueFromParams = { from: "company"; companyId: number; fromActiveHook?: boolean } | { from: "shipping-company"; companyId: number; fromActiveHook?: boolean };

/**
 * Retorna o state correto dependendo do from e fromActiveHook usando type guards
 * Garante ordem dos hooks
 */
export function useGetQueueFrom(params: UseGetQueueFromParams) {
  const { companyId, fromActiveHook = false } = params;

  // Chame todos os hooks incondicionalmente
  const queueActiveFromCompanyState = useGetQueueActiveByCompanyQuery({ id: companyId }, { skip: !isCompanyParams(params) || !fromActiveHook });
  const queueActiveFromShippingCompanyState = useGetQueueActiveByShippingCompanyQuery({ id: companyId }, { skip: !isShippingCompanyParams(params) || !fromActiveHook });
  const queueFromCompanyState = useGetQueueByCompanyQuery({ id: companyId }, { skip: !isCompanyParams(params) || fromActiveHook });
  const queueFromShippingCompanyState = useGetQueueByShippingCompanyQuery({ id: companyId }, { skip: !isShippingCompanyParams(params) || fromActiveHook });

  // type guards só para organizar qual state retornar
  if (isCompanyParams(params)) {
    return fromActiveHook ? queueActiveFromCompanyState : queueFromCompanyState;
  }
  return fromActiveHook ? queueActiveFromShippingCompanyState : queueFromShippingCompanyState;
}

export const {
  useGetQueueByCompanyQuery,
  useGetQueueActiveByCompanyQuery,
  useGetQueueTotalsByCompanyQuery,
  useGetQueueDelayStatusByCompanyQuery,
  useGetQueueShippingCompanyPositionsQuery,
  useGetQueueDriverPositionQuery,
  useGetQueueActiveByShippingCompanyQuery,
  useGetQueueByShippingCompanyQuery,
  useGetQueueQuery,
  useGetQueueNextDateByCompanyQuery,
  useLazyGetQueueDriverPositionQuery,
  useLazyGetQueueQuery,
  useToggleQueueDelayMutation,
  useSaveQueueStartMutation,
  useSaveQueueUpdateDriverMutation,
  useSaveQueueUpdateMutation,
  useSaveQueueCloseByIdMutation,
  useSaveQueueDeleteMutation
} = queueApi;
